import {
    AfterViewInit,
    Component,
    Input,
    OnInit,
    ViewChild,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { WizardSlide } from '../../models/wizard-slide';
import { ContainerWizardSlideCreationService } from '../../services/container-wizard-slide-creation.service';
import { ImgDbWizardSlideCreationService } from '../../../img-db/component/services/img-db-wizard-slide-creation.service';
import { WizardSlideComponent } from '../wizard-slide/wizard-slide.component';
import {
    ContainerCreateRequest,
    ContainerType,
} from 'src/app/shared/models/container.types';

@Component({
    selector: 'app-project-wizard',
    templateUrl: './container-wizard.component.html',
    styleUrls: ['./container-wizard.component.scss'],
    providers: [
        ContainerWizardSlideCreationService,
        ImgDbWizardSlideCreationService,
    ],
    standalone: false,
})
export class ContainerWizardComponent implements OnInit, AfterViewInit {
    @Input() type: ContainerType;
    @Input() config: {
        slideIndex?: number;
        creationData?: Partial<ContainerCreateRequest>;
    };
    @ViewChild('childComponent') slideComponent: WizardSlideComponent;
    wizardIndexActive: number = 1;
    wizardDataList: Array<WizardSlide>;

    wizardPointPath: string = 'assets/img/create-project-modal/';
    wizardPointImages: string[] = [
        this.wizardPointPath + '1.jpg',
        this.wizardPointPath + '2.jpg',
        this.wizardPointPath + '3.jpg',
    ];
    headlineTranslationKey: string;

    constructor(
        public modalService: NgbModal,
        private projectWizardService: ContainerWizardSlideCreationService
    ) {}
    ngAfterViewInit(): void {
        if (this.config?.creationData) {
            this.slideComponent.createDto = {
                ...this.slideComponent.createDto,
                ...this.config.creationData,
            };
        }
    }

    ngOnInit(): void {
        this.wizardIndexActive = 1;
        this.changeActivePositionPoint();
        this.headlineTranslationKey =
            'project.components.projectWizard.createNewProject';
        if (this.type === ContainerType.IMAGE_DB) {
            this.headlineTranslationKey = 'imgDb.wizard.createNewDb';
        }
        this.wizardDataList = this.projectWizardService.createWizardSlides(
            this.type
        );
        if (this.config?.slideIndex) {
            this.wizardDataList = this.wizardDataList.slice(
                this.config.slideIndex
            );
            this.wizardDataList.forEach((slide) => {
                slide.id = slide.id - this.config.slideIndex;
            });
            this.wizardPointImages = this.wizardPointImages.slice(
                this.config.slideIndex
            );
            this.wizardPointImages = this.wizardPointImages.map(
                (image, index) =>
                    index === 0 ? image.replace('.jpg', '-active.jpg') : image
            );
        }
    }

    changeWizardPosition(event: number) {
        this.wizardIndexActive = event;
        this.changeActivePositionPoint();
    }

    private changeActivePositionPoint() {
        this.wizardPointImages = this.wizardPointImages
            .map((image) => image.replace('-active', ''))
            .map((image) =>
                image.replace(
                    this.wizardIndexActive + '.jpg',
                    this.wizardIndexActive + '-active.jpg'
                )
            );
    }

    addProjectSuccessfully(event: string) {
        if (event === 'closeModal') {
            this.modalService.dismissAll();
        }
    }

    onBackButton() {
        this.slideComponent.onGoBack();
        this.changeWizardPosition(--this.wizardIndexActive);
    }
}
